/* eslint-disable @typescript-eslint/no-explicit-any */
import { defineStore } from 'pinia';
import { AccessApiService } from '~packages/epk-front-shared/api-client';

import getConstants from '@/constants';

import { kId } from '../config';
import type { IItemDto } from './types';

const { isModeDevelopment } = getConstants();

const baseStateFactory = () => ({
  isInited: false,
  listStorage: [] as IItemDto[],
  lvlMap: {} as Record<string, number>,
  map: {} as Record<string, IItemDto>,
  page: -1,
});

const includesLetter = (str: string): boolean => {
  return /[a-zA-Zа-яА-Я]/.test(str);
};

export const useAccessOktmoStore = defineStore('access-oktmo-with-orgs', {
  state: () => ({
    ...baseStateFactory(),
    as: new AccessApiService(),
    size: isModeDevelopment ? 20 : 50,
    search: '',
  }),
  actions: {
    async load(page: number, cb: (arr: IItemDto[]) => void) {
      const params = { page, size: this.size, sort: ['oktmo'] } as Record<
        string,
        unknown
      >;

      const str = this.search;
      if (str) {
        if (includesLetter(str)) {
          params.locality__ilike = str + '%';
          params.org_name__ilike__OR = str + '%';
        } else {
          params.oktmo__like = str + '%';
        }
      }

      const r = await this.as.oktmosWithOrgs(params);

      if (r.status) {
        const arr = r.response.data;
        if (arr) {
          cb(arr);
        }
      }

      return r;
    },
    async get() {
      return this.listStorage;
    },
    init() {
      this.reset();
      this.isInited = true;
    },
    async pageNext() {
      const map = this.map;

      return this.load(++this.page, arr => {
        const listStorage = this.listStorage;
        arr?.forEach(i => {
          listStorage.push(i);

          /*  */
          const id = i[kId];
          map[id] = i;
        });
      });
    },
    reset() {
      const baseState = baseStateFactory();
      for (const k in baseState) {
        this[k] = baseState[k as keyof typeof baseState];
      }
    },
  },
});
